// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RunStatus = {
    Pending: 'PENDING',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    PartiallyCompleted: 'PARTIALLY_COMPLETED',
    Failed: 'FAILED'
} as const;
export type RunStatus = typeof RunStatus[keyof typeof RunStatus];


export function instanceOfRunStatus(value: any): boolean {
    for (const key in RunStatus) {
        if (Object.prototype.hasOwnProperty.call(RunStatus, key)) {
            if (RunStatus[key as keyof typeof RunStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RunStatusFromJSON(json: any): RunStatus {
    return RunStatusFromJSONTyped(json, false);
}

export function RunStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunStatus {
    return json as RunStatus;
}

export function RunStatusToJSON(value?: RunStatus | null): any {
    return value as any;
}

export function RunStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): RunStatus {
    return value as RunStatus;
}
